import { clientPersistor, clientStore } from 'src/redux/clientStore';
import { adminPersistor, adminStore } from 'src/redux/adminStore';

export const logoutClientStore = async () => {
  await clientPersistor.purge();
  clientStore.dispatch({ type: 'RESET_STORE' });
};

export const logoutAdminStore = async () => {
  await adminPersistor.purge();
  adminStore.dispatch({ type: 'RESET_ADMIN_STORE' });
};

export const logoutAllStores = async () => {
  await Promise.all([clientPersistor.purge(), adminPersistor.purge()]);

  clientStore.dispatch({ type: 'RESET_STORE' });
  adminStore.dispatch({ type: 'RESET_ADMIN_STORE' });
};
